import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";

export const varifyCaptcha = createAsyncThunk(
  "login/varifyCaptcha",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/verify-captcha", payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong",
      );
    }
  },
);

export const getProvidersDetails = createAsyncThunk(
  "providers/getProvidersDetails",
  async ({ provider, deviceType = 2 }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get(`/provider/${provider}`, {
        headers: {
          "Device-Type": deviceType,
        },
      });

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || err.message || "Something went wrong",
      );
    }
  },
);

export const addEnquiry = createAsyncThunk(
  "prvoders/addEnquiry",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/add-customer-inquiry", payload);
      // console.log("The res of sent enquiry is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);

export const getCountryCode = createAsyncThunk(
  "prvoders/getCountryCode",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-country");
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err?.message || err || "Somethig went wrong",
      );
    }
  },
);

export const getFaqs = createAsyncThunk(
  "providers/getFaqs",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-faqs-detail");
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);

export const getLandingDetail = createAsyncThunk(
  "providers/getLandingDetail",
  async (
    { page = 1, search = "", vegOnly = "", orders = "", price = "" },
    { rejectWithValue },
  ) => {
    try {
      const res = await axiosInstance.get("/landing-page/providers", {
        params: {
          page,
          search,
          is_pure_veg_food: vegOnly ? 1 : "",
          sort_orders: orders,
          sort_price: price,
        },
      });

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err?.message || "Something went wrong",
      );
    }
  },
);

export const submitWebsiteQuery = createAsyncThunk(
  "providers/submitWebsiteQuery",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/submit-website-query", payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);
